class Lego {
    identify(email) {
        let xhttp = new XMLHttpRequest();
        let id = document.head.querySelector('meta[name="lego-id"]');

        if (!id) {
            return console.error(
                'Cannot identify email because Lego ID was not found: https://docs.hlx.dev/lego/store-front/layouts#lego-id'
            );
        }

        xhttp.open('POST', '/api/email-capture', true);
        xhttp.setRequestHeader('Content-type', 'application/json');
        xhttp.setRequestHeader('Accept', 'application/json');
        xhttp.send(
            JSON.stringify({
                email: email,
                lego_id: id.content,
            })
        );
    }
}

export default new Lego();
